module.exports = __webpack_public_path__ + "img/defaultImgSmall.dadd09ad.png";